import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Footer from "../Component/Footer/Footer";
import HistoryPage from "../NewPages/HistoryPage/HistoryPage";
import Listen from "../Listen";
import HomePage from "../NewPages/HomePage/HomePage";
import OpenPage from "../Pages/OpenPage/OpenPage";
import NewSearchPage from "../NewPages/SearchPage/Searchpage";
import SearchPage from "../Pages/SearchPage/SearchPage";
import NewProfilePage from "../NewPages/NewProfilePage/NewProfilePage";
import NotFound from "../Pages/NotFound/NotFound";
import {
  DOES_NOT_EXIST,
  Home_PAGE_URL,
  OPEN_QUESTIONS,
  SEARCH_PAGE_URL,
  HISTORY_PAGE_URL,
  TRENDING_PAGE_URL,
  RECOMMEND_PAGE_URL,
  ANSWERED_QUESTION,
  FAVOURITE_QUESTION,
  SHARED_BY,
  SHARED_WITH,
  KEYTAG_DATA,
  KEYTERM_DATA,
  PROFILE_PAGE_URL,
  URL_REDIRECTION_URL,
  ATOMIZER_CM,
  EXPERT_STAT_URL,
  EXPERT_EDITOR_URL,
  KNOWLEDGE_ENTRY,
  GRAPHS_COMPONENTS,
  SHARED_FOLDERS,
  CM_SEARCH_SUGGESTION_DETAIL_PAGE,
  CM_INGESTED_KNOWLEDGE,
  CM_SEARCH_SUGGESTIONS,
  EXPERT_RECORDS,
  EXPERT_RECORDS_DETAILS,
  MY_DOWNLOAD,
  USER_PERMISSIONS,
  Manage_Role,
  Restrict_permission,
  ADMIN_SETTINGS,
  SAVED_TABS,
  AGENT_BRIEF,
  SAVED_BRIEF,
  NEW_EDITOR_URL,
  HEALTHS,
  CURATED_VIEW,
  EMAIL_TICKET_DETAILS,
  LOGIN_URL
} from "./routerUrl";
import TrendingPage from "../Pages/TrendingPage/TrendingPage";
import NewTrendingPage from "../NewPages/TrendingPage/TrendingPage";
import RecommendPage from "../Pages/RecommendPage/RecommendPage";
import RecommendPageNew from "../NewPages/RecommendPage/RecommendPageNew";
import AnsweredPage from "../Pages/CommonPage/AnsweredPage";
import FavouritePage from "../Pages/CommonPage/FavouritePage";
import ShareByPage from "../Pages/CommonPage/SharedByPage";
import ShareWithPage from "../Pages/CommonPage/SharedWithPage";
import KeyTagData from "../Pages/KeyTagDataPage/index";
import KeyTermPage from "../Pages/keyTermPage/KeyTermPage";
import ProfilePage from "../Pages/ProfilePage/ProfilePage";
import UrlRedirection from "../Pages/UrlRedirection/UrlRedirection";
import AtomizerPage from "../Pages/AtomizerPage/AtomizerPage";
import { CURRENT_ROLE } from "../API/url";
import MyStatePage from "../Pages/MyStatePage/myStatePage";
import KnowledgeEntryPage from "../Pages/KnowledgeEntryPage/KnowledgeEntryPage";
import EditorPage from "../Pages/EditorPage/EditorPage";
// import ExpertProfilePage from "../Pages/ExpertProfilePage/ExpertProfilePage";
import ExpertProfilePage from "../NewPages/ExpertProfilePage/ExpertProfilePage";
import AllModals from "../Component/Modals/allModals";
import CMExpertOverviewPage from "../Pages/CMExpertOverviewPage/CMExpertOverviewPage";
import SharedFolders from "../Pages/SharedFoldersCM/SharedFolders";
import CmHomePage from "../Pages/CmHomePage/CmHomePage";
// import CmSearchSuggestionsPage from "../Pages/CmSearchSuggestionsPage/CmSearchSuggestionsPage";
// import SearchSuggestionDetailPage from "../Pages/SearchSuggestionDetailPage/SearchSuggestionDetailPage";
import CmProfilePage2 from "../Pages/CmProfilePage/CmProfilePage2";
import MainPage from "../Pages/ExpertRecordspage/MainPage";
import ExpertRecordsPageDetails from "../Pages/ExpertRecordsPageDetails/ExpertRecordsPageDetails";
import DownloadPage from "../NewPages/DownloadPage/DownloadPage";
import CmSearchSuggestionsPage from "../Pages/CmSearchSuggestionsPage/CmSearchSuggestionsPage";
import SearchSuggestionDetailPage from "../Pages/SearchSuggestionDetailPage/SearchSuggestionDetailPage";
import AdminProfilePage from "../Pages/CmProfilePage/AdminProfilePage";
import CmIngestedPage from "../Pages/CmIngestedPage/CmIngestedPage";
import AdminHome from "../Pages/AdminHome/AdminHome";
import ManagePermissions from "../Pages/AdminManagePermissions/ManagePermissions";
import ManageRole from "../Pages/AdminMangeRole/ManageRole";
import AdminRestrictPermission from "../Pages/AdminRestrictPermission/AdminRestrictPermission";
import AdminSettingsPage from "../Pages/AdminSettings/AdminSettings";
// import NewProfilePage from "../Pages/ProfilePage/NewProfilePage";
import NewKeyTermPage from "../NewPages/KeyTermPage/NewKeyTermPage";
import SeekerAnsweredPage from "../NewPages/SeekerAnsweredPage/SeekerAnsweredPage";
import NewOpenPage from "../NewPages/OpenPage/NewOpenPage";
import SavedPages from "../NewPages/SavedPages/SavedPages";
import NewEditorPage from "../NewPages/NewEditorPage/NewEditorPage";
import NewTrendingExpertPage from "../NewPages/TrendingExpertPage/TrendingPage";
import NewKeyTermExpertPage from "../NewPages/KeyTermExpertPage/NewKeyTermPage";
import NewSearchExpertpage from "../NewPages/SearchExpertPage/Searchpage";
import SavedExpertPages from "../NewPages/SavedExpertPages/SavedPages";
import ExpertMyStats from "../NewPages/ExpertMyStats/ExpertMyStats";
import NewKnowledgeEntryPage from "../NewPages/NewKnowledgeEntryPage/NewKnowledgeEntryPage";
import ExpertOpenPage from "../NewPages/ExpertOpenPage/ExpertOpenPage";
import Briefing from "../NewPages/Agents/Briefing/Briefing";
import Saved from "../NewPages/Agents/Saved/Saved";
import { useSelector } from "react-redux";
import ExpertAnswered from "../NewPages/ExpertAnswered/ExpertAnswered";
import Healths from "../NewPages/Healths/Healths";
import CuratedAnsweresPage from "../NewPages/CuratedAnswered";
import CuratedAnsweredPage from "../NewPages/CuratedAnswered";
import EmailHome from "../NewPages/EmailHome/EmailHome";
import TicketDetails from "../NewPages/EmailHome/ticketDetails";
import EmailSetting from "../NewPages/EmailHome/EmailSetting";
import Login from "../NewPages/Login/Login";
// import Login from "../NewPages/Login/Login";
import ExternalLogin from "../NewPages/Login/ExternalLogin";
import SSOError from "../NewPages/Login/SSOError";
import GoogleError from "../NewPages/Login/GoogleError";
import AppStatus from "../NewPages/AppStatus/AppStatus";
import EmailAction from "../NewPages/EmailAction/EmailAction";

const jsessionid = localStorage.getItem("JSESSIONID");

export default function Router() {
  const userState = useSelector(state => state.user);
  Listen();
  let mybutton = document.getElementById("myBtn");
  window.onscroll = function () {
    scrollFunction();
  };
  // mybutton.style.display = "none";
  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      if (mybutton !== null) {
        mybutton.style.display = "block";
      }
    } else {
      if (mybutton !== null) {
        mybutton.style.display = "none";
      }
    }
  }
  const ScrollTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };
  return (
    <>
      <Routes>
        <Route path='/health' element={<Healths />} />
        <Route path='/uptime' element={<AppStatus />} />
        {jsessionid === null && <Route path='/login_error' element={<SSOError />} />}
        {jsessionid !== null && <Route path='/emailAction/:id' element={<EmailAction />} />}
        <Route path='/auth_error' element={<GoogleError />} />
        {jsessionid === null && <Route path='/login' element={<Login />} />}
        {jsessionid === null && <Route path='/login/authenticated' element={<ExternalLogin />} />}
        {CURRENT_ROLE === "Seeker" && userState.roles !== undefined && (
          <>
            <Route path={Home_PAGE_URL} element={<HomePage />} />
            <Route path={SEARCH_PAGE_URL} element={<NewSearchPage />} />
            <Route
              path={DOES_NOT_EXIST}
              element={<Navigate to={Home_PAGE_URL} replace />}
            />
            {userState.agenticEnabled && <Route path={SAVED_BRIEF} element={<Saved />} />}
            <Route path={HISTORY_PAGE_URL} element={<HistoryPage />} />
            {/* <Route path={TRENDING_PAGE_URL} element={<TrendingPage />} /> */}
            {/* <Route path={RECOMMEND_PAGE_URL} element={<RecommendPage />} /> */}
            <Route path={RECOMMEND_PAGE_URL} element={<RecommendPageNew />} />
            <Route path={TRENDING_PAGE_URL} element={<NewTrendingPage />} />
            <Route path={RECOMMEND_PAGE_URL} element={<RecommendPage />} />
            <Route path={OPEN_QUESTIONS} element={<NewOpenPage />} />
            <Route path={ANSWERED_QUESTION} element={<SeekerAnsweredPage />} />
            <Route path={FAVOURITE_QUESTION} element={<FavouritePage />} />
            <Route path={SAVED_TABS} element={<SavedPages />} />
            <Route path={SHARED_BY} element={<ShareByPage />} />
            <Route path={SHARED_WITH} element={<ShareWithPage />} />
            <Route path={KEYTAG_DATA} element={<KeyTagData />} />
            <Route path={KEYTERM_DATA} element={<NewKeyTermPage />} />
            {/* <Route path={PROFILE_PAGE_URL} element={<ProfilePage />} /> */}
            <Route path={PROFILE_PAGE_URL} element={<NewProfilePage />} />
            <Route path={URL_REDIRECTION_URL} element={<UrlRedirection />} />
            <Route path={MY_DOWNLOAD} element={<DownloadPage />} />
            {userState.agenticEnabled && <Route path={AGENT_BRIEF} element={<Briefing />} />}
          </>
        )}
        {CURRENT_ROLE === "Expert" && userState.roles !== undefined &&
          <>
            {userState.agenticEnabled && <Route path={AGENT_BRIEF} element={<Briefing />} />}
            {userState.agenticEnabled && <Route path={SAVED_BRIEF} element={<Saved />} />}
            <Route path={SEARCH_PAGE_URL} element={<NewSearchExpertpage />} />
            <Route
              path={DOES_NOT_EXIST}
              element={<Navigate to={OPEN_QUESTIONS} replace />}
            />
            {/* <Route path={TRENDING_PAGE_URL} element={<TrendingPage />} /> */}
            <Route path={TRENDING_PAGE_URL} element={<NewTrendingExpertPage />} />
            {/* <Route path={RECOMMEND_PAGE_URL} element={<RecommendPage />} /> */}
            <Route path={RECOMMEND_PAGE_URL} element={<RecommendPageNew />} />
            {/* <Route path={OPEN_QUESTIONS} element={<OpenPage />} /> */}
            <Route path={OPEN_QUESTIONS} element={<ExpertOpenPage />} />
            {/* ExpertAnswered */}
            {/* <Route path={ANSWERED_QUESTION} element={<AnsweredPage />} />  */}
            {/* <Route path={ANSWERED_QUESTION} element={<ExpertAnswered />} /  > */}
            <Route path={ANSWERED_QUESTION} element={<CuratedAnsweredPage />} />
            <Route path={FAVOURITE_QUESTION} element={<FavouritePage />} />
            <Route path={SHARED_BY} element={<ShareByPage />} />
            <Route path={SHARED_WITH} element={<ShareWithPage />} />
            <Route path={KEYTAG_DATA} element={<KeyTagData />} />
            <Route path={KEYTERM_DATA} element={<NewKeyTermExpertPage />} />
            {/* <Route path={PROFILE_PAGE_URL} element={<ExpertProfilePage />} /> */}
            <Route path={PROFILE_PAGE_URL} element={<ExpertProfilePage />} />
            <Route path={URL_REDIRECTION_URL} element={<UrlRedirection />} />
            {/* <Route path={EXPERT_STAT_URL} element={<MyStatePage />} /> */}
            <Route path={EXPERT_STAT_URL} element={<ExpertMyStats />} />
            <Route path={KNOWLEDGE_ENTRY} element={<NewKnowledgeEntryPage />} />
            {/* <Route path={KNOWLEDGE_ENTRY} element={<KnowledgeEntryPage />} /> */}

            {/* <Route path={CURATED_VIEW} element={<CuratedAnsweredPage />} /> */}
            <Route path={EXPERT_EDITOR_URL} element={<NewEditorPage />} />
            <Route path={SAVED_TABS} element={<SavedExpertPages />} />
          </>
        }
        {CURRENT_ROLE === "CM" && userState.roles !== undefined &&
          <>
            <Route path={Home_PAGE_URL} element={<CmHomePage />} />
            <Route
              path={DOES_NOT_EXIST}
              element={<Navigate to={Home_PAGE_URL} replace />}
            />
            <Route path={CM_INGESTED_KNOWLEDGE} element={<CmIngestedPage />} />
            <Route path={SHARED_FOLDERS} element={<SharedFolders />} />
            <Route path={PROFILE_PAGE_URL} element={<CmProfilePage2 />} />
            <Route
              path={CM_SEARCH_SUGGESTIONS}
              element={<CmSearchSuggestionsPage />}
            />
            <Route
              path={CM_SEARCH_SUGGESTION_DETAIL_PAGE}
              element={<SearchSuggestionDetailPage />}
            />
            <Route path={ATOMIZER_CM} element={<AtomizerPage />} />
            <Route path={EXPERT_RECORDS} element={<MainPage />} />
            <Route
              path={EXPERT_RECORDS_DETAILS}
              element={<ExpertRecordsPageDetails />}
            />
            <Route
              path={GRAPHS_COMPONENTS}
              element={<CMExpertOverviewPage />}
            />
            {userState.agenticEnabled && <Route path={SAVED_BRIEF} element={<Saved />} />}
          </>
        }
        {CURRENT_ROLE === "Admin" && userState.roles !== undefined &&
          <>
            <Route path={Home_PAGE_URL} element={<AdminHome />} />
            <Route
              path={DOES_NOT_EXIST}
              element={<Navigate to={Home_PAGE_URL} replace />}
            />
            <Route path={USER_PERMISSIONS} element={<ManagePermissions />} />
            <Route path={Manage_Role} element={<ManageRole />} />

            <Route path={PROFILE_PAGE_URL} element={<AdminProfilePage />} />
            {/* <Route path={USER_PERMISSIONS} element={< ManagePermissions/>} /> */}
            <Route
              path={Restrict_permission}
              element={<AdminRestrictPermission />}
            />
            <Route path={ADMIN_SETTINGS} element={<AdminSettingsPage />} />
          </>
        }
        {CURRENT_ROLE === "Emails" && userState.roles !== undefined &&
          <>
            <Route path={Home_PAGE_URL} element={<EmailHome />} />
            <Route
              path={DOES_NOT_EXIST}
              element={<Navigate to={Home_PAGE_URL} replace />}
            />
            <Route path={EMAIL_TICKET_DETAILS} element={<TicketDetails />} />
            <Route path={PROFILE_PAGE_URL} element={<EmailSetting />} />

          </>
        }
      </Routes>
      <AllModals />
      <div className="gototop" id="myBtn">
        <i
          class="fa fa-arrow-circle-o-up"
          aria-hidden="true"
          onClick={() => ScrollTop()}
        ></i>
      </div>
      {/* <Footer/> */}
      {/* <AllModals/> */}
    </>
  );
}
